import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const useTrustedDomains = () => {
    const {customParams} = getConfig()

    const trustedList = [
        'https://google.com',
        'https://googletagmanager.com',
        'https://www.google.com',
        'https://www.googletagmanager.com',
        'https://sgtm.delonghi.com',
        'https://sgtm.braunhousehold.com',
        'https://sgtm.kenwoodworld.com',
        'https://sgtm.nutribullet.com',
        'https://cdns.eu1.gigya.com',
        'https://cloud.news.delonghi.com',
        `https://${customParams?.currentHost}`,
        'https://www.youtube.com',
        'https://consent.trustarc.com',
        'https://cdns.eu1.gigya.com',

        // Wildcard domains
        '*.paypal.com',
    ]

    /**
     * Checks if an origin is trusted, supporting wildcard domains (e.g. *.paypal.com)
     * @param {string} origin - The message origin to check
     * @param {string[]} trustedList - List of trusted origins
     * @returns {boolean}
     */
    const isTrustedOrigin = (origin) => {
        // Always trust the current window origin (SSR safe check)
        if (typeof window !== 'undefined' && origin === window.location.origin) {
            return true
        }

        return trustedList.some((trusted) => {
            // Handle wildcard domains (e.g. *.paypal.com)
            if (trusted.startsWith('*.')) {
                try {
                    const trustedHostname = trusted.slice(2) // Remove "*."
                    const originUrl = new URL(origin)

                    return (
                        originUrl.hostname === trustedHostname ||
                        originUrl.hostname.endsWith(`.${trustedHostname}`)
                    )
                } catch {
                    return false
                }
            }

            // Exact match for standard origins
            return trusted === origin
        })
    }

    return {isTrustedOrigin}
}
